import React, { useEffect } from 'react';
import _ from 'lodash';
import { connectDynamic } from 'go/components/dynamic/dynamicComponent';
import { connect } from 'react-redux';
import DynamicComponentActions from 'go/actions/dynamicComponent';

export const ValidationListener = (props) => {
    const {
        validationErrors,
        runValidations
    } = props;

    useEffect(() => {
        if (!validationErrors.isLoading && runValidations) {
            _.forIn(validationErrors.errors, (errorList, validationId) => {
                _.forEach(errorList, errorObj => {
                    if (errorObj.isValid === false ) {
                        props.triggerDirtyMap(validationId);
                        return false;
                    }
                })
            })
            props.saveEntitySessionData("runValidations", false, null);
        }
    });
    return <></>;
};

export const mapStateToProps = (state) => {
    const { validationErrors, runValidations } = state.dynamicComponent;
    return {
        validationErrors,
        runValidations,
    };
};

export const mapDispatchToProps = (dispatch) => ({
    triggerDirtyMap: (fieldPath) =>
        dispatch(DynamicComponentActions.triggerDirtyMap(fieldPath)),
    saveEntitySessionData: (dataPath, data, fieldName) =>
        dispatch(
            DynamicComponentActions.saveEntitySessionData(dataPath, data, fieldName, false)
        ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ValidationListener);
